import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const LogOut = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        id="nova-LogOut"
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 26C19.2716 26 22.1763 24.4289 24.0007 22H26.3946C24.3198 25.5868 20.4417 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C20.4417 4 24.3198 6.41319 26.3946 10H24.0007C22.1763 7.57111 19.2716 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26ZM25.707 12.2933L28.707 15.2933C29.098 15.6842 29.098 16.3163 28.707 16.7073L25.707 19.7073C25.512 19.9023 25.256 20.0003 25 20.0003C24.744 20.0003 24.488 19.9023 24.293 19.7073C23.902 19.3163 23.902 18.6842 24.293 18.2933L25.5861 17.0003H16C15.448 17.0003 15 16.5523 15 16.0003C15 15.4483 15.448 15.0003 16 15.0003H25.5861L24.293 13.7073C23.902 13.3163 23.902 12.6842 24.293 12.2933C24.684 11.9022 25.316 11.9022 25.707 12.2933Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default LogOut
